import { canonicalizeDealerAccountPath } from "@/context/account/dealerAccountRouteId";
import { useAccount } from "@/context/account";
import { canonicalizeCustomerPath } from "@/context/customer/customerRouteId";
import { useCustomerAccountIdsStore } from "@/store/useCustomerAccountIdsStore";
import { format } from "@/utils/format";

export function useNotificationTargetUri(contentUri: string): string {
  const { accounts } = useAccount();
  const iamIdByCdhId = useCustomerAccountIdsStore(
    (state) => state.iamIdByCdhId
  );
  return canonicalizeCustomerPath(
    canonicalizeDealerAccountPath(format.notificationUri(contentUri), accounts),
    iamIdByCdhId
  );
}
